'use strict'

import TweenLite from 'gsap';
import axios from 'axios';

let self;

export default self = {
    container: document.querySelector('.buildings'),
    buildings: [],
    endpoint: 'buildings?per_page=100',

    init : () => {
        TweenLite.staggerFromTo('.building', 1, {y: 20}, {y: 0, autoAlpha: 1}, 0.15);
        axios
            .get(`/wp-json/wp/v2/${self.endpoint}`)
            .then(res => {
                if(res){
                    self.buildings.push(...res.data);
                    TweenLite.to('.building-filter', 1, {autoAlpha: 1});
                }
            })
            .catch(err => {
                console.error(err);
            });

        const filters = document.querySelectorAll('.building-filter li');
        [...filters].forEach( f => {
            f.addEventListener('click', e => {
                 switch(e.target.dataset.filter){
                    case 'coal':
                        self.displayMatches('coal harbour');
                    break;
                    case 'downtown':
                        self.displayMatches('downtown');
                    break;
                    case 'yaletown':
                        self.displayMatches('yaletown');
                    break;
                    case 'west':
                        self.displayMatches('west end');
                    break;
                    default:
                        self.displayMatches();
                };
            });
        });

    },

    findMatches : (filterName, buildings) => {
        if(filterName) {
            return buildings.filter((d)=> d.acf.neighbourhood.trim().toLowerCase() == filterName);
        }
        return buildings;
    },

    displayMatches : (filter) => {
        const matchArray = self.findMatches(filter, self.buildings);

        const html = matchArray.map(building => {
            return `
            <li class="building">
                <a href="${building.link}">
                    <img src=${building.acf.illustratoin} alt="">

                    <div class="content">
                      <p class="title"><strong>${building.title.rendered}</strong></p>
                      <div class="meta">
                        ${ building.acf.address && `<p> ${building.acf.address}</p>`}
                        ${ building.acf.floors && `<p> ${building.acf.floors} floors</p>`}
                        ${ building.acf.total_number_of_residences && `<p> ${building.acf.total_number_of_residences} ft</p>`}
                        ${ building.acf.year_built && `<p> ${building.acf.year_built}</p>`}
                        <p class="building__detail__link">See Details</p>
                      </div>
                    </div>
                </a>
            </li>
            `
        }).join('');

        self.container.innerHTML = html;
        TweenLite.staggerFromTo('.building', 1, {y: 40}, {y: 0, autoAlpha: 1}, 0.2);
    }

}
